import { render, staticRenderFns } from "./requestCtr.vue?vue&type=template&id=1c252050"
import script from "./requestCtr.vue?vue&type=script&lang=js"
export * from "./requestCtr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports